/**
 * Variants for ValidationPopup-style toasts (`tooltip` + `type` + optional `icon`).
 * Icons must exist in `src/data/IconCompo.js` (some call sites use names that are not
 * registered yet — this list is what actually renders).
 */
export const VALIDATION_ALERT_VARIANTS = [
  {
    key: "error-horror",
    type: "error",
    icon: "horror",
    message: "Something went wrong. Try again.",
  },
  {
    key: "error-error",
    type: "error",
    icon: "horror",
    message: "Validation or server error.",
  },
  {
    key: "success-like",
    type: "success",
    icon: "like",
    message: "Saved successfully.",
  },
  {
    key: "success-ok",
    type: "success",
    icon: "ok",
    message: "Account updated.",
  },
  {
    key: "loading-spinner",
    type: "loading",
    icon: "loading_ani",
    message: "Loading…",
  },
  {
    key: "loading-ani",
    type: "loading",
    icon: "loading_ani",
    message: "Please wait…",
  },
  {
    key: "info-loading",
    type: "info",
    icon: "loading_ani",
    message: "Sending confirmation…",
  },
  {
    key: "info-loading-ani",
    type: "info",
    icon: "loading_ani",
    message: "Checking credentials…",
  },
  {
    key: "info-plain",
    type: "info",
    icon: "caution",
    message: "Info message without an icon.",
  },
  {
    key: "warning-caution",
    type: "warning",
    icon: "caution",
    message: "Please review this field.",
  },
];
